module.exports = __webpack_public_path__ + "static/img/2016.82670d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2016.jpg
// module id = 307
// module chunks = 0